































































import Vue from "vue";
import Paragraph from "@/components/Text/Global/Paragraph.vue";
import StandartCard from "@/components/Card/StandartCard/StandartCard.vue";
import Utils from "@/utils/utils";
import { store } from "@/store/store";

export default Vue.extend({
  name: "InformationCard",
  components: { Paragraph, StandartCard },
  props: {
    survey: {
      type: Object
    }
  },
  computed: {
    displayStartDate(): string {
      return Utils.transformDateToYMD(this.survey.start_date);
    },
    displayEndDate(): string {
      return Utils.transformDateToYMD(this.survey.end_date);
    },
    displayAgence(): string {
      return store.getters.AGENCE_BY_ID[this.survey.agence].name;
    },
    displayCreator(): string {
      return store.getters.USER_BY_ID[this.survey.user].mail;
    }
  }
});
